import Vue from "vue"
let VueFunc:any = new Vue()
export default VueFunc